import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CreatePensionForm } from "web_myplann/Portfolio/Pages/PensionCreate/CreatePensionForm";
import { PortfolioAddLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioAddLayout";

export const AddPensionPage = () => {
	const { t } = useResource();

	return (
		<PortfolioAddLayout title={t(Resources.Portfolio.AddPension.title)}>
			<CreatePensionForm />
		</PortfolioAddLayout>
	);
};
